module.exports = __webpack_public_path__ + "img/metro_L4.416d791d.svg";